module.exports = __webpack_public_path__ + "static/media/lidar.701aae00.png";